const BUNDLES = {
  daily: { variantId: '58029008486782' },
  complete: { variantId: '58029008519550' },
};

const route = (path) => {
  const root = window.Shopify?.routes?.root || '/';
  return root + path.replace(/^\//, '');
};

async function jsonFetch(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const data = await response.json();
  if (!response.ok || data?.status >= 400) {
    throw new Error(data?.description || data?.message || 'Cart update failed');
  }
  return data;
}

async function addNativeBundle(bundleKey) {
  const bundle = BUNDLES[bundleKey];
  if (!bundle) throw new Error('Unknown KOFARA ritual');

  return jsonFetch(route('cart/add.js'), {
    method: 'POST',
    body: JSON.stringify({
      items: [{ id: Number(bundle.variantId), quantity: 1 }],
    }),
  });
}

function openCartAfterReload() {
  if (sessionStorage.getItem('kofara-open-cart') !== '1') return;
  sessionStorage.removeItem('kofara-open-cart');

  customElements.whenDefined('theme-drawer').then(() => {
    requestAnimationFrame(() => {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  });
}

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-kofara-bundle]') : null;
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();
  if (button.disabled) return;

  const original = button.textContent;
  const loading = button.dataset.loadingText || 'Adding…';
  const error = button.dataset.errorText || 'Please try again';

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = loading;

  try {
    await addNativeBundle(button.dataset.kofaraBundle || '');
    sessionStorage.setItem('kofara-open-cart', '1');
    window.location.reload();
  } catch (err) {
    console.error('[KOFARA native bundles]', err);
    button.textContent = error;
    setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = original || '';
    }, 1800);
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openCartAfterReload, { once: true });
} else {
  openCartAfterReload();
}
